<div class="modal-header"
     *ngIf="isModal">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="10"
                     class="ion-no-padding">
                {{ 'DASHBOARD_NOTIFICATIONS' | translate }}
            </ion-col>
            <ion-col size="2"
                     class="ion-no-padding ion-text-right">
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark">
                    </svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<ng-container *ngIf="loading">
    <div class="content-centered-column loading">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>

<div class="notification-list">
    <ng-container *ngIf="!loading && user">
        <ion-row *ngIf="this.plt.dashboardFeeds.length == 0">
            <ion-col class="no-records ion-no-padding">
                <div class="empty-data">
                    <svg-icon *ngIf="plt.sizeSm"
                              [applyClass]="true"
                              src="/assets/icons/ico-eye.svg"
                              class="icon fill-light"></svg-icon>
                    <h3>{{ 'DASHBOARD_NOTIFICATIONS_NONE' | translate }}</h3>
                </div>
            </ion-col>
        </ion-row>
        <ng-container *ngFor="let feed of plt.dashboardFeeds">
            <ion-row class="item {{ feed.data.type }} ion-no-padding"
                     [ngClass]="{ 'visited': feed.visited_at }">
                <ion-col (click)="openFeedDetail(feed)"
                         [size]="!plt.sizeSm ? 8 : 10"
                         class="pointer ion-no-padding">
                    <ion-item>
                        <div class="picture">
                            <ion-avatar *ngIf="!feed.source_participant || feed.isMarketplaceType"
                                        class="small-radius">
                                <ion-skeleton-text animated></ion-skeleton-text>
                                <img img-logo
                                     [src]="event.logo_url"
                                     [alt]="event.name">
                            </ion-avatar>
                            <ion-avatar *ngIf="!feed.isMarketplaceType && feed.source_participant && user && user.canPicture(feed.source_participant)"
                                        slot="start">
                                <img img-avatar
                                     [src]="feed.source_participant.picture_url">
                            </ion-avatar>
                            <ion-avatar *ngIf="feed.source_participant && user && !user.canPicture(feed.source_participant)"
                                        slot="start">
                                <img img-avatar
                                     [src]="''">
                            </ion-avatar>
                            <svg-icon *ngIf="feed.data.type == 'like' || feed.data.type == 'newsfeed-like' || feed.data.type == 'marketplace-post-like'"
                                      [applyClass]="true"
                                      src="/assets/icons/ico-like.svg"
                                      class="ico-like"></svg-icon>
                            <svg-icon *ngIf="feed.data.type == 'visit' || feed.data.type == 'marketplace-post-visit'"
                                      [applyClass]="true"
                                      src="/assets/icons/ico-eye.svg"
                                      class="ico-visit"></svg-icon>
                            <svg-icon *ngIf="feed.data.type == 'message' || feed.data.type == 'newsfeed-comment' || feed.data.type == 'marketplace-post-comment'"
                                      [applyClass]="true"
                                      src="/assets/icons/ico-message.svg"
                                      class="ico-message"></svg-icon>
                        </div>
                        <ion-label>
                            <ng-container *ngIf="feed.isMarketplaceType">
                                <h2>{{ feed.marketplace.translate(userLang).name }}</h2>
                                <p>{{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT' | translate: {data: feed.data} }}</p>
                            </ng-container>
                            <ng-container *ngIf="!feed.isMarketplaceType">
                                <h2>
                                    <ng-container *ngIf="feed.source_participant">{{ feed.source_participant.firstname }} {{ feed.source_participant.lastname }} </ng-container>
                                    <ng-container *ngIf="!feed.source_participant && feed.data.participant_name">{{ feed.data.participant_name }} </ng-container>
                                    <span *ngIf="!plt.sizeSm && feed.source_participant">
                                        <ng-container *ngIf="feed.source_participant.profession">{{ feed.source_participant.profession }}</ng-container>
                                        <ng-container *ngIf="feed.source_participant.profession && (feed.source_participant.company || feed.source_participant.city)">, </ng-container>
                                        <ng-container *ngIf="feed.source_participant.company || feed.source_participant.city">
                                            <ng-container *ngIf="feed.source_participant.company">{{ feed.source_participant.company }}</ng-container>
                                            <ng-container *ngIf="feed.source_participant.company && feed.source_participant.city">, </ng-container>
                                            <ng-container *ngIf="feed.source_participant.city">{{ feed.source_participant.city }}</ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="feed.source_participant.profession || feed.source_participant.company || feed.source_participant.city"> - </ng-container>
                                    </span>
                                </h2>
                                <p>

                                    <ng-container *ngIf="plt.sizeSm && feed.source_participant">
                                        <ng-container *ngIf="feed.source_participant.profession">{{ feed.source_participant.profession }}</ng-container>
                                        <ng-container *ngIf="feed.source_participant.profession && (feed.source_participant.company || feed.source_participant.city)">, </ng-container>
                                        <ng-container *ngIf="feed.source_participant.company || feed.source_participant.city">
                                            <ng-container *ngIf="feed.source_participant.company">{{ feed.source_participant.company }}</ng-container>
                                            <ng-container *ngIf="feed.source_participant.company && feed.source_participant.city">, </ng-container>
                                            <ng-container *ngIf="feed.source_participant.city">{{ feed.source_participant.city }}</ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="feed.source_participant.profession || feed.source_participant.company || feed.source_participant.city"> - </ng-container>
                                    </ng-container>

                                    <ng-container *ngIf="feed.data.type == 'newsfeed-created'">
                                        <ng-container *ngIf="event.newsfeed_post_visibility == 'keywords-limit'">
                                            {{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT_KEYWORD_LIMIT' | translate: {data: feed.data, count: event.newsfeed_keywords_limit} }}
                                        </ng-container>
                                        <ng-container *ngIf="event.newsfeed_post_visibility != 'keywords-limit'">
                                            {{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT' | translate: {data: feed.data} }}
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="feed.data.type != 'newsfeed-created'">
                                        {{ 'FEED_' + feed.data.type.toUpperCase() + '_TEXT' | translate: {data: feed.data} }}
                                    </ng-container>
                                </p>
                            </ng-container>

                        </ion-label>
                    </ion-item>

                </ion-col>
                <ion-col size="2"
                         class="action-buttons"
                         *ngIf="plt.sizeSm && user && user.canMessage(feed.source_participant) && !feed.source_participant.not_contactable"
                         (click)="goToMessages(feed.source_participant.id)">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-message.svg"
                              class=""></svg-icon>
                </ion-col>

                <ion-col *ngIf="!plt.sizeSm "
                         size=4
                         class="action-buttons ion-text-right">
                    <a *ngIf="user.canMessage(feed.source_participant) && feed.source_participant.public_email && !user.selected_participant?.not_contactable && user.selected_participant?.id != feed.source_participant.id"
                       [attr.href]="!user.canMessage(feed.source_participant) ? null : 'mailto:' + feed.source_participant.public_email">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/ico-mail.svg">
                        </svg-icon>
                    </a>
                    <a *ngIf="user.canMessage(feed.source_participant) && feed.source_participant.phone && !user.selected_participant?.not_contactable && user.selected_participant?.id != feed.source_participant.id"
                       [attr.href]="!user.canMessage(feed.source_participant) ? null : 'tel:' + feed.source_participant.phone">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/ico-phone.svg">
                        </svg-icon>
                    </a>
                    <a *ngIf="feed.source_participant?.linkedin_profile"
                       onclick="window.open(this.href, '_system');return false"
                       [attr.href]="feed.source_participant.linkedin_profile">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/ico-linkedin.svg">
                        </svg-icon>
                    </a>
                    <a *ngIf="feed.source_participant?.xing_profile"
                       onclick="window.open(this.href, '_system');return false"
                       [attr.href]="feed.source_participant.xing_profile">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/ico-xing.svg">
                        </svg-icon>
                    </a>

                    <a *ngIf="user && user.canMessage(feed.source_participant) && !feed.source_participant.not_contactable"
                       (click)="goToMessages(feed.source_participant.id)"
                       class="pointer">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/ico-message.svg"
                                  class=""></svg-icon>
                    </a>
                </ion-col>

            </ion-row>
        </ng-container>
    </ng-container>
</div>